import React, { ComponentType, Fragment } from 'react';

type Component = ComponentType | React.FC<any> | [ComponentType | React.FC<any>, Record<string, any>];

export interface ComposeProvidersProps {
	components: Component[];
}

const Compose: React.FunctionComponent<ComposeProvidersProps> = ({ components, children }) => {
	return (
		<Fragment>
			{components.reverse().reduce((acc, curr) => {
				const [Provider, props] = Array.isArray(curr) ? [curr[0], curr[1]] : [curr, {}];
				return <Provider {...props}>{acc}</Provider>;
			}, children)}
		</Fragment>
	);
};

export default Compose;
